import { ISoundEffect } from '@typings/setting/soundEffect.interface';
import { atom } from 'recoil';

export const soundEffectState = atom<ISoundEffect | any>({
  key: 'soundEffectState',
  default: {},
});
